module.exports = __webpack_public_path__ + "static/media/iconReporting.3d1dd32c.svg";